<div class="modal fade" :id="modalComponentId" tabindex="-1" role="dialog" :aria-labelledby="modalComponentId + 'Label'" aria-hidden="true">
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" :id="modalComponentId + 'Label'">{{modalHeading}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="onModalCloseClick">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="alert alert-success alert-dismissible fade show" role="alert" v-if="showSuccessMessage">
                    {{successMessage}}
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="clearMessageAlerts">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="showErrorMessage">
                    {{errorMessage}}
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="clearMessageAlerts">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <data-table
                    :headings="companiesLinkedAndUnlinkedToDiscountGroupHeadings"
                    :data="companiesLinkedAndUnlinkedToDiscountGroup"
                    :pagingDetails="pagingDetails"
                    :hasNoPaging="false"
                    :stateChanged="false"
                    :hasActions="true"
                    :hasCustomActionComponent="true"
                    @pagingUpdated="onPagingUpdated"
                    @filterSearchClicked="onFilterSearchClicked"
                    v-if="!loading">
                    <template #filter>
                        <div class="p-3">
                            <div class="input-group pb-4">
                                <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" v-model="searchQuery">
                                <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon1">
                                        <i class="fas fa-search"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template #actionComponent="{ companyId, isLinked }">
                        <input type="checkbox" :checked="isLinked" @change="onCompanyCheckOrUncheck(companyId)">
                    </template>
                </data-table>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-success" @click="onModalSaveClick" :disabled="loading" v-if="!showSuccessMessage && !showErrorMessage">SAVE</button>
                <button type="button" class="btn btn-secondary" :disabled="loading" data-dismiss="modal" @click="onModalCloseClick" v-if="!showSuccessMessage && !showErrorMessage">CLOSE</button>
                <button type="button" class="btn btn-primary" :disabled="loading" v-if="showSuccessMessage || showErrorMessage" @click="clearMessageAlerts">OK</button>
            </div>
        </div>
    </div>
</div>